import { CommonDao, commonDaoFactory } from './common-dao-factory'
import { InterceptorFunction } from '../axios/axios-dao-factory'
import { authorizationHeaderInterceptor } from '../axios/interceptor/authorization-header-interceptor'
import { refreshTokenInterceptor } from '../axios/interceptor/refresh-token-interceptor'
import { BackendType } from '../enum/backend-type'

export const coreDaoFactory = ({
  onError,
  interceptors = [],
}: {
  onError?: (error: Error) => Promise<void>
  interceptors?: InterceptorFunction[]
} = {}): CommonDao =>
  commonDaoFactory({
    backendType: BackendType.CORE,
    onError,
    interceptors: [...interceptors, authorizationHeaderInterceptor, refreshTokenInterceptor],
  })
